module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/placeholder-payment-card-c1d58abd1a5c6f9e11fe45a6da7d13b6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/placeholder-payment-card.svg
// module id = ClSI
// module chunks = 24